<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
  <p>{{text}}</p>
  <hr />

  <ul>
  <li *ngFor="let token of secondaryTokens">
      {{token}}
    </li>
  </ul>

</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button (click)="onNoClick()" cdkFocusInitial>{{cancel}}</button>
  <button mat-raised-button (click)="onYesClick()" color="primary">{{confirm}}</button>
</div>
